export default __webpack_public_path__ + "static/img/vogue_scene_animated_0176.d613e72.jpg";